import type { ReactNode } from "react";
import { NbfcLink } from "./NbfcLink";
import { TOTAL_APPLICATION_STEPS } from "./ApplicationJourney";

const linkClass = "text-[#CC1A1A] underline hover:text-red-800";

const faqs: { question: string; answer: ReactNode }[] = [
  {
    question: "Who can apply for a loan?",
    answer: (
      <>
        Salaried Indian citizens with a monthly take-home salary of ₹35,000 or more. See the full{" "}
        <a href="/#eligibility" className={linkClass}>eligibility criteria</a>.
      </>
    ),
  },
  {
    question: "How many steps are in the application?",
    answer: (
      <>
        {TOTAL_APPLICATION_STEPS} steps, all completed online. See{" "}
        <a href="/apply-now" className={linkClass}>what happens at each step</a>.
      </>
    ),
  },
  {
    question: "Which documents do I need?",
    answer: "Your PAN Card, Aadhaar Card, bank statement and salary slips.",
  },
  {
    question: "Do I need collateral or a guarantor asset?",
    answer: "No. You do not need to pledge jewellery or property.",
  },
  {
    question: "How much will my loan cost?",
    answer: (
      <>
        Use the <a href="/#loan-calculator" className={linkClass}>loan calculator</a> for an estimate. Your
        actual rate, fees and repayment amount depend on your profile and are shared in your sanction letter.
      </>
    ),
  },
  {
    question: "Can I repay my loan early?",
    answer: "Yes. There are no pre-closure or prepayment charges.",
  },
  {
    question: "How do I repay my loan safely?",
    answer: (
      <>
        Use only the{" "}
        <a href={import.meta.env.VITE_WEBSITE_REPAY_LINK} className={linkClass}>official repayment page</a>.
        Verify your number with an OTP, select your loan, and review the principal, interest, penalties and
        total before you pay. Do not pay through UPI links or payment links sent to you by anyone else.
      </>
    ),
  },
  {
    question: "What happens if I miss a payment?",
    answer: "Late or non-payment may result in fees and can affect your ability to get future loans.",
  },
  {
    question: "Who is the lender?",
    answer: (
      <>
        Loans are provided by our NBFC partner, <NbfcLink className={linkClass} />.
      </>
    ),
  },
  {
    question: "How do I raise a complaint?",
    answer: (
      <>
        Follow our <a href="/grievance-redressal-policy" className={linkClass}>Grievance Redressal Policy</a>.
        We aim to respond within 7 business days.
      </>
    ),
  },
];

export const FaqSection = () => {
  return (
    <section className="py-15 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col items-center text-center mb-10">
          <span className="text-[#CC1A1A] text-xs font-black tracking-[0.3em] uppercase mb-3">
            FAQ
          </span>
          <div className="w-8 h-0.5 bg-[#CC1A1A] mb-5" />
          <h2 className="text-4xl xl:text-5xl font-bold text-[#1a1a4e] mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq) => (
            <details key={faq.question} className="rounded-xl border border-gray-200 px-5 py-4">
              <summary className="cursor-pointer text-[#1a1a4e] font-semibold text-base">
                {faq.question}
              </summary>
              <p className="text-gray-500 text-sm leading-relaxed mt-3">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
